/* Apra — extras do cabecalho: reduz o seletor de idioma a codigo (PT/EN)
   e reposiciona o icone de favoritos + botao de orcamento no cabecalho.
   Ficheiro externo com cache -- antes ia embutido em todas as paginas. */
(function () {
  function encurtarIdioma() {
    document.querySelectorAll('.localization-form__select[name="language_code"] option').forEach(function (op) {
      var codigo = (op.getAttribute('lang') || op.value || '').split('-')[0].toUpperCase();
      if (codigo && op.textContent.trim() !== codigo) op.textContent = codigo;
    });
  }

  function colocarExtras() {
    var extras = document.getElementById('apra-header-extras');
    if (!extras) return;
    var direita = document.querySelector('.header__column--right');
    if (!direita) return;

    var idioma = direita.querySelector('localization-form-component');
    var ancora = idioma;
    while (ancora && ancora.parentNode !== direita) ancora = ancora.parentNode;

    var fav = extras.querySelector('.apra-fav');
    var cta = extras.querySelector('.apra-cta');

    if (fav) direita.insertBefore(fav, ancora || direita.firstChild);
    if (cta) direita.appendChild(cta);

    extras.parentNode.removeChild(extras);
  }

  function correr() {
    encurtarIdioma();
    colocarExtras();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', correr);
  } else {
    correr();
  }
  setTimeout(correr, 500);
})();
